import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { useDispatch } from "react-redux";
import {
  setBlacklist,
  setBlacklistRecovery,
  signOutUser,
  updateAppMode,
} from "../../redux/actions/actionCreators";
import { MyAccount } from "../../screens/new/my-account";
import { MyUnits } from "../../screens/more/my-units";
import { Header } from "../../components/new/header/header";
import { translate } from "../../i18n";
import { AppMode } from "../../enums";

const Stack = createStackNavigator();

export function MoreSummaryStack({ navigation }: any) {
  const dispatch = useDispatch();

  return (
    <Stack.Navigator
      initialRouteName="Settings"
      screenOptions={{
        header: (props) => <Header {...props} />,
        headerMode: "screen",
        showFullMenu: true,
      }}>
      <Stack.Screen
        name="Settings"
        component={MyAccount}
        options={() => ({
          title: translate("myAccount.workflowTitle"),
          omitRightContent: false,
          rightContentText: translate("moreStack.logout"),
          rightContentOnPress: () => {
            dispatch(setBlacklist(false));
            dispatch(setBlacklistRecovery(false));
            dispatch(updateAppMode(AppMode.NORMAL));
            dispatch(signOutUser());
          },
        })}
      />
      <Stack.Screen
        name="MyUnits"
        component={MyUnits}
        options={() => ({
          title: "My Unit(s)",
          useLight: true,
          omitRightContent: true,
        })}
      />
    </Stack.Navigator>
  );
}
